"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CornerOverlay = void 0;
// src/services/component-injection-manager/ui/corner-overlay.tsx
var preact_1 = require("preact");
var models_1 = require("../models");
var styles = __importStar(require("./corner-overlay.scss"));
var CornerOverlay = function (_a) {
    var _b;
    var children = _a.children, position = _a.position;
    var positionClass = (_b = {},
        _b[models_1.InjectionPosition.TopLeft] = styles.topLeft,
        _b[models_1.InjectionPosition.TopRight] = styles.topRight,
        _b[models_1.InjectionPosition.BottomLeft] = styles.bottomLeft,
        _b[models_1.InjectionPosition.BottomRight] = styles.bottomRight,
        _b[models_1.InjectionPosition.SideBySide] = '' // Not used for corner overlay
    ,
        _b)[position];
    return ((0, preact_1.h)("div", { className: "".concat(styles.cornerOverlay, " ").concat(positionClass), "aria-live": "polite" }, children));
};
exports.CornerOverlay = CornerOverlay;
